import { Button, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { Dialog } from "@mui/material";
import { useTranslation } from "react-i18next";

interface WarningDraftBranchProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function WarningDraftBranch({ open, onCancel, onConfirm }: WarningDraftBranchProps) {
  const { t } = useTranslation();

  return (
    <Dialog 
      open={open} 
      onClose={(_, reason) => {
        // Evitamos que al hacer click fuera del modal se cierre
        if (reason === "backdropClick") return;
        onCancel();
      }}
      PaperProps={{
        sx: {
          borderRadius: "16px",
          maxWidth: "450px",
          width: "100%",
        }
      }}
    >
      <DialogTitle
        sx={{
          padding: "24px 24px 16px",
          fontWeight: 600,
          fontSize: "20px",
          fontFamily: "Montserrat",
          color: "#1E1E1E",
          "&.MuiDialogTitle-root": {
            fontFamily: "Montserrat",
          },
        }}
      >
        {t("branches.create.warning-draft-branch.title")}
      </DialogTitle>
      <DialogContent
        sx={{
          padding: "0 24px 24px",
          fontFamily: "Montserrat",
          color: "#666666",
          "& p": {
            margin: 0,
            fontSize: "14px",
            lineHeight: "1.5",
            fontFamily: "Montserrat",
          }
        }}
      >
        <Typography>
          {t("branches.create.warning-draft-branch.content")}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          padding: "0 24px 24px",
          gap: "12px",
        }}
      >
        <Button
          sx={{
            fontFamily: "Montserrat",
            color: "#EF0BB8",
            fontSize: "14px",
            textTransform: "none",
            fontWeight: 400,
            padding: "8px 24px",
            borderRadius: "16px",
            border: "1px solid #EF0BB8",
            minWidth: "120px",
            "&:hover": {
              backgroundColor: "rgba(239, 11, 184, 0.04)",
            },
          }}
          onClick={onCancel}
        >
          {t("branches.create.warning-draft-branch.cancel")}
        </Button>
        <Button
          sx={{
            fontFamily: "Montserrat",
            backgroundColor: "#EF0BB8",
            color: "#fff",
            fontSize: "14px",
            textTransform: "none",
            fontWeight: 400,
            padding: "8px 24px",
            borderRadius: "16px",
            minWidth: "120px",
            "&:hover": {
              backgroundColor: "#d109a3",
            },
            "&.Mui-disabled": {
              opacity: "40%",
              color: "#fff",
            },
          }}
          onClick={onConfirm}
        >
          {t("branches.create.warning-draft-branch.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
